<template>
  <div class="layout-scroller layout-scroller--has-dots">
    <dpc-scroller
      class="layout-scroller__teaser-scroller"
      config-preset="teaser-scroller"
      :has-button-next="false"
      :has-button-previous="false"
      :has-dots="true"
      :current-index="currentIndex"
      @update:currentIndex="handleUpdate"
    >
      <slot />
    </dpc-scroller>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentIndex: 1,
    };
  },
  methods: {
    handleUpdate(newIndex) {
      this.currentIndex = newIndex;
    },
  },
};
</script>
